import { ProfileState } from 'src/modules/profile/types/ProfileState';
import { RootState } from 'src/types/RootState';

export function getProfileState(state: RootState): ProfileState {
  return state.profile;
}
